export default {
  readMore: 'Mehr lesen',
  fullText: 'Vollständiger Text',
};
